/**
 * How complete a content search's answer is. `isPartial`: the RPC returned a
 * full page, so matches may be missing. `contentUnavailable`: it failed, and
 * the caller is showing filename matches only.
 *
 * A pure module, imported directly rather than through the repository barrel:
 * store tests `vi.mock("../repository")` with partial stubs, and a constant
 * reachable only through the barrel comes back undefined inside them.
 */
export interface ContentSearchStatus {
  isPartial: boolean;
  contentUnavailable: boolean;
}

export const COMPLETE_CONTENT_SEARCH: ContentSearchStatus = {
  isPartial: false,
  contentUnavailable: false,
};
